// eslint-disable-next-line no-restricted-imports
import { Dropdown } from 'semantic-ui-react';
import { hoursOptions } from '../../../config';

const HourPicker: React.FC = ({ ...rest }) => (
  <Dropdown {...rest} options={hoursOptions} selectOnBlur={false} clearable />
);

export default HourPicker;
